export default function PHP_ftp_delete() {
  return (
    <div>
      <h1>PHP_ftp_delete</h1>
    </div>
  );
}
